import React, {Component} from 'react';
import {Link} from "react-router-dom";
import "./style.scss"

class TopNav extends Component {
    render() {
        return (
            <div className="TopNav">
                <Link className="item" to="/">首页</Link>
                <Link className="item" to="/user">用户管理</Link>
                <Link className="item" to="/member">会员管理</Link>
                <Link className="item" to="/antd">antd</Link>
            </div>
        )
    }
}

export default TopNav;

